var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { staticClass: "pa-0", attrs: { cols: "12" } },
            [
              _c("SButton", {
                attrs: {
                  sText: _vm.$t(
                    "teamRequestDetail.buttonGroup.client.savedAndNotAllStemdoersAvailable.primaryButtonText"
                  ),
                  btnStyle: "primary",
                  action: _vm.openAcceptOnlyAvailablesStemdoersModal,
                  disabled: _vm.teamRequest.areAllStemdoersNotAvailable(),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-0 mt-4", attrs: { cols: "12" } },
            [
              _c("SButton", {
                attrs: {
                  sText: _vm.$t(
                    "teamRequestDetail.buttonGroup.client.savedAndNotAllStemdoersAvailable.secondaryButtonText"
                  ),
                  btnStyle: "secondary",
                  action: _vm.openSaveTRModal,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }